module.exports = __webpack_public_path__ + "static/media/id.b50a3553.svg";